// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TkwZ","label":"styles_label__1MQE_"};